import React, { useEffect, useRef } from 'react';
import { LiveManagedRuntime } from 'services/layer';
import { RuntimeContext } from './runtimeСontext';

export const EffectRuntimeProvider: React.FC<{
  children: React.ReactNode;
  runtime: LiveManagedRuntime;
}> = ({ children, runtime }) => {
  const mountRef = useRef(false);

  useEffect(() => {
    if (!mountRef.current) {
      mountRef.current = true;
      return;
    }

    return () => {
      runtime.dispose();
    };
  }, [runtime]);

  return <RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>;
};
